module.exports = __webpack_public_path__ + "img/calendarcom.d1e5390.gif";